export default {
	NoData: 'Pas de données dans les options du champs',
	Delete: 'Supprimer',
	AddOne: 'Ajouter un élément',
};
